/* =============================================================================
   mhv-browse-as.js — admin "Browse as customer" identity override (view-as)
   -----------------------------------------------------------------------------
   Loaded EARLY (before the per-page MHV_*_CONFIG blocks) so those blocks can call
   MHVBrowseAs.patch(cfg) right after they assign their config. When an admin has
   started a browse-as session (from the Utilities "Browse as customer" tool), this:
     1. swaps the AUTH credential — window.MHV_CUSTOMER_KEY becomes the target's key
        (or null for "guest"), read by mhv-fetch.js on every request;
     2. patches DISPLAY/URL identity fields on each MHV_*_CONFIG to the target;
     3. shows a persistent "Browsing as X — Stop" banner.
   State lives in localStorage['mhv_browse_as'] and persists until Stop.
   ============================================================================= */
(function () {
  'use strict';
  var KEY = 'mhv_browse_as';
  var raw = null;
  try { raw = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { raw = null; }
  var active = !!(raw && raw.active);
  var guest = !!(raw && raw.guest);

  function label() {
    if (!active) return '';
    if (guest) return 'Guest (logged out)';
    return (((raw.firstName || '') + ' ' + (raw.lastName || '')).trim()) || raw.screenName || raw.email || ('Customer ' + (raw.customerId || ''));
  }

  var API = {
    active: active,
    guest: guest,
    identity: raw || null,
    key: (raw && raw.apiKey) || null,
    label: label(),

    // Override a config object's customer-identity fields in place (target, or blank for guest).
    patch: function (cfg) {
      if (!active || !cfg || typeof cfg !== 'object') return cfg;
      var v = function (field) { return guest ? '' : (raw[field] || ''); };
      var id = guest ? null : (raw.customerId || null);
      if ('customer' in cfg) {
        if (guest) {
          cfg.customer = null; // guest = fully logged out
        } else if (cfg.customer && typeof cfg.customer === 'object') {
          var c = cfg.customer;
          if ('id' in c) c.id = id;
          if ('firstName' in c) c.firstName = v('firstName');
          if ('lastName' in c) c.lastName = v('lastName');
          if ('screenName' in c) c.screenName = v('screenName');
          if ('bidderNumber' in c) c.bidderNumber = v('bidderNumber');
          if ('consignorNumber' in c) c.consignorNumber = v('consignorNumber');
          if ('profileImage' in c) c.profileImage = v('profileImage');
          if ('badge' in c) c.badge = '';
        }
      }
      if ('customerId' in cfg) cfg.customerId = id;
      if ('customerEmail' in cfg) cfg.customerEmail = v('email');
      if ('bidderNumber' in cfg) cfg.bidderNumber = v('bidderNumber');
      if ('consignorNumber' in cfg) cfg.consignorNumber = v('consignorNumber');
      if ('screenName' in cfg) cfg.screenName = v('screenName');
      if ('firstName' in cfg) cfg.firstName = v('firstName');
      if ('lastName' in cfg) cfg.lastName = v('lastName');
      if ('profileImage' in cfg) cfg.profileImage = v('profileImage');
      return cfg;
    },

    // Override the high-visibility SERVER-RENDERED identity spots ({{ customer.* }} in
    // Liquid, which browse-as can't change server-side): the header greeting, and the
    // account page's name label + bidder badge. (Shopify-native order history stays real.)
    patchDom: function () {
      if (!active) return;
      var greet = document.querySelector('#MiniAuctionMenu-account span');
      if (greet) {
        if (guest) { var menu = document.querySelector('.miniaccountmenu'); if (menu) menu.style.display = 'none'; }
        else { greet.textContent = 'Hi, ' + (raw.screenName || raw.firstName || 'there') + '!'; }
      }
      if (!guest) {
        var lbl = document.querySelector('.mhv-page-header__label');
        if (lbl && raw.firstName && /'s Account/i.test(lbl.textContent)) lbl.textContent = raw.firstName + "'s Account";
        var badge = document.querySelector('.bidder-number-badge');
        if (badge && raw.bidderNumber && badge.firstChild && badge.firstChild.nodeType === 3) badge.firstChild.nodeValue = raw.bidderNumber;
      }
    },

    start: function (blob) {
      blob.active = true;
      try { localStorage.setItem(KEY, JSON.stringify(blob)); } catch (e) { /* quota */ }
      window.location.href = '/';
    },
    stop: function () {
      try { localStorage.removeItem(KEY); } catch (e) { /* noop */ }
      window.location.href = '/';
    }
  };

  // Auth override: the target's key becomes the active credential (or null → logged-out).
  if (active) {
    var applyKey = function () { if (API.active) window.MHV_CUSTOMER_KEY = guest ? null : (raw.apiKey || null); };
    applyKey();
    // header.liquid provisions MHV_CUSTOMER_KEY asynchronously (App Proxy) — re-assert after.
    document.addEventListener('DOMContentLoaded', applyKey);
    setTimeout(applyKey, 1500);
  }

  window.MHVBrowseAs = API;

  // The "Browsing as X" indicator lives at the bottom of the customer hamburger menu
  // (rendered by header-drawer.liquid) — no fixed on-screen bar.
  if (active) {
    // Override server-rendered identity spots once the DOM is ready (+ retries for
    // elements the page rehydrates late).
    var doPatch = function () { API.patchDom(); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', doPatch);
    else doPatch();
    setTimeout(doPatch, 800);
    setTimeout(doPatch, 2000);
  }
})();
